/**
 * @generated SignedSource<<0e3cf1ccb5ce94f19c874ccf4fc4c366>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ActiveRecords = "ACTIVE" | "BOTH" | "INACTIVE" | "%future added value";
export type ClassesFilterInput = {
  haveAtLeastOneStudent?: boolean | null | undefined;
  isActive: ActiveRecords;
  siteIds?: ReadonlyArray<string> | null | undefined;
  siteIsActive: ActiveRecords;
};
export type ClassesGetByTeacherIdQuery$variables = {
  filter?: ClassesFilterInput | null | undefined;
  skip?: boolean | null | undefined;
  teacherId: string;
};
export type ClassesGetByTeacherIdQuery$data = {
  readonly classesByTeacherId?: ReadonlyArray<{
    readonly externalSync: {
      readonly source: string | null | undefined;
    } | null | undefined;
    readonly gradeLevels: ReadonlyArray<{
      readonly id: string;
      readonly name: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly id: string;
    readonly isActive: boolean;
    readonly name: string | null | undefined;
    readonly owner: {
      readonly firstName: string | null | undefined;
      readonly id: string;
      readonly lastName: string | null | undefined;
    } | null | undefined;
    readonly section: string | null | undefined;
    readonly site: {
      readonly id: string;
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly users: ReadonlyArray<{
      readonly classes: ReadonlyArray<{
        readonly name: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly firstName: string | null | undefined;
      readonly gradeLevels: ReadonlyArray<{
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly id: string;
      readonly isActive: boolean;
      readonly lastName: string | null | undefined;
      readonly publicUserId: string | null | undefined;
      readonly roles: ReadonlyArray<{
        readonly name: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly sites: ReadonlyArray<{
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly userClasses: ReadonlyArray<{
        readonly class: {
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined;
        readonly isActive: boolean;
      } | null | undefined> | null | undefined;
    } | null | undefined> | null | undefined;
  }>;
};
export type ClassesGetByTeacherIdQuery = {
  response: ClassesGetByTeacherIdQuery$data;
  variables: ClassesGetByTeacherIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v1 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "skip"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teacherId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "classesFilterInput",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "teacherId",
    "variableName": "teacherId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "section",
  "storageKey": null
},
v7 = [
  (v4/*: any*/),
  (v5/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "SiteNode",
  "kind": "LinkedField",
  "name": "site",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v9 = [
  (v5/*: any*/),
  (v4/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "GradeLevelNode",
  "kind": "LinkedField",
  "name": "gradeLevels",
  "plural": true,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publicUserId",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "ClassNode",
  "kind": "LinkedField",
  "name": "class",
  "plural": false,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v16 = [
  (v5/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "SiteNode",
  "kind": "LinkedField",
  "name": "sites",
  "plural": true,
  "selections": (v7/*: any*/),
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "UserNode",
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/)
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "source",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ClassesGetByTeacherIdQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "ClassNode",
            "kind": "LinkedField",
            "name": "classesByTeacherId",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNode",
                "kind": "LinkedField",
                "name": "users",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserClassNode",
                    "kind": "LinkedField",
                    "name": "userClasses",
                    "plural": true,
                    "selections": [
                      (v11/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoleNode",
                    "kind": "LinkedField",
                    "name": "roles",
                    "plural": true,
                    "selections": (v16/*: any*/),
                    "storageKey": null
                  },
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClassNode",
                    "kind": "LinkedField",
                    "name": "classes",
                    "plural": true,
                    "selections": (v16/*: any*/),
                    "storageKey": null
                  },
                  (v10/*: any*/)
                ],
                "storageKey": null
              },
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ExternalSyncNode",
                "kind": "LinkedField",
                "name": "externalSync",
                "plural": false,
                "selections": [
                  (v19/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ClassesGetByTeacherIdQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "ClassNode",
            "kind": "LinkedField",
            "name": "classesByTeacherId",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNode",
                "kind": "LinkedField",
                "name": "users",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserClassNode",
                    "kind": "LinkedField",
                    "name": "userClasses",
                    "plural": true,
                    "selections": [
                      (v11/*: any*/),
                      (v15/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoleNode",
                    "kind": "LinkedField",
                    "name": "roles",
                    "plural": true,
                    "selections": (v9/*: any*/),
                    "storageKey": null
                  },
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClassNode",
                    "kind": "LinkedField",
                    "name": "classes",
                    "plural": true,
                    "selections": (v9/*: any*/),
                    "storageKey": null
                  },
                  (v10/*: any*/)
                ],
                "storageKey": null
              },
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ExternalSyncNode",
                "kind": "LinkedField",
                "name": "externalSync",
                "plural": false,
                "selections": [
                  (v19/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "b3128b03d204af5651b6b56267fde986",
    "id": null,
    "metadata": {},
    "name": "ClassesGetByTeacherIdQuery",
    "operationKind": "query",
    "text": "query ClassesGetByTeacherIdQuery(\n  $filter: ClassesFilterInput\n  $teacherId: ID!\n  $skip: Boolean = false\n) {\n  classesByTeacherId(classesFilterInput: $filter, teacherId: $teacherId) @skip(if: $skip) {\n    id\n    name\n    section\n    site {\n      id\n      name\n    }\n    gradeLevels {\n      name\n      id\n    }\n    isActive\n    users {\n      id\n      firstName\n      lastName\n      publicUserId\n      isActive\n      userClasses {\n        isActive\n        class {\n          id\n          name\n        }\n        id\n      }\n      roles {\n        name\n        id\n      }\n      sites {\n        id\n        name\n      }\n      classes {\n        name\n        id\n      }\n      gradeLevels {\n        name\n        id\n      }\n    }\n    owner {\n      id\n      firstName\n      lastName\n    }\n    externalSync {\n      source\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f226216af6cdf2dc1745a43226e58c89";

export default node;
